import { FormattedNumber } from 'react-intl';
import { config } from '../../../utils/config';

const FormattedCurrency = ({ value }: { value: number }) => (
  <FormattedNumber
    value={value}
    style="currency"
    currency={config.currency}
    currencyDisplay={config.formats.currency}
  />
);

export default FormattedCurrency;
